import { useEffect, useState } from "react";
import axios from "axios";
import "../../assets/css/login.css";
import { FORUM_SETTINGS_PUBLIC } from "../../routes/routes";
import { FullPageLoader } from "../../components/common/Loader";

/**
 * Shared public legal page loader (Terms / Privacy).
 * @param {{ settingKey: string, fallbackTitle: string, errorMessage: string }} props
 */
const ForumLegalPublicPage = ({
  settingKey,
  fallbackTitle,
  errorMessage,
}) => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(FORUM_SETTINGS_PUBLIC, {
        params: { key: settingKey },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          document.title = res.data.data?.title || fallbackTitle;
          setContent(res.data.data?.content || "");
        }
      })
      .catch(() => {
        setError(errorMessage);
      })
      .finally(() => setLoading(false));
  }, [settingKey, fallbackTitle, errorMessage]);

  return (
    <div className="forum-legal-wrapper" style={{ backgroundColor: "#fff" }}>
      <FullPageLoader visible={loading} />
      {!loading && error && <p className="text-danger">{error}</p>}
      {!loading && !error && (
        <div
          className="forum-legal-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default ForumLegalPublicPage;
